import React, { useMemo, useCallback, useState } from 'react';

import DataTable from '../../../components/DataTable';
import useAlunos, { ALUNOS_FILTERS } from './useAlunos';
import { Box, CircularProgress, IconButton, Link, Typography } from '@material-ui/core';
import { DeleteForever, Edit } from '@material-ui/icons';
import AdminMenu from '../../../components/Admin/MenuDetalhes/AdminMenu';
import { producaov2 } from '../../../services/apis';
import { systemLogs } from '../../../services/system_logs';
import { toast } from 'react-toastify';

function AlunoActions({ id, onDelete }) {
  const [loadingDelete, setLoadingDelete] = useState(false);

  const deleteAluno = useCallback(
    async () => {
      swal(
        "Exclusão de conta",
        "Deseja realmente deletar essa conta?",
        "error",
        {
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            cancel: {
              text: "Cancelar",
              value: false,
              visible: true,
              className: "",
              closeModal: true,
            },
            confirm: {
              text: "Confirmar",
              value: true,
              visible: true,
              className: "",
              closeModal: true,
            },
          },
        }
      ).then(async value => {
        setLoadingDelete(true);

        if (value) {
          try {
            await producaov2.delete(`/admin/alunos/${id}`);
            systemLogs("alunos", `deletou o aluno de id=${id}`);

            onDelete();

          } catch (err) {
            toast.error('Houve um erro ao deletar o aluno')
            return err;
          }
        } else {
          return;
        }
      })
      .finally(() => {
        setLoadingDelete(false);
      });
    },
    [id]
  );

  return (
    <Box>
      <IconButton title="Editar aluno" size="small" component="a" href={`/admin/alunos/detalhes/${id}`} target="_blank">
        <Edit color="primary" />
      </IconButton>
      <IconButton title="Excluir aluno" size="small" onClick={deleteAluno} disabled={loadingDelete}>
        {loadingDelete ? <CircularProgress size={14} /> : <DeleteForever color="error" />}
      </IconButton>
    </Box>
  )
}

export default function Alunos() {
  const {
    data,
    total,
    filters,
    page,
    isLoading,
    rowsPerPage,
    changeFilters,
    resetFilters,
    changePage,
    changeRowsPerPage,
    refreshData
  } = useAlunos();

  const rows = useMemo(() => {
    if(!data) {
      return [];
    }

    return data?.map(row => {
      return {
        id: row?.id,
        name: row?.nome,
        email: row?.email,
        phone: row?.celular,
        actions: <AlunoActions {...row} onDelete={refreshData} />
      }
    })
  }, [data, refreshData]);

  return (
    <Box width="100%" paddingLeft="250px">
      <Box width="100%" padding="1rem">
        <AdminMenu />
        <DataTable
          showFilters
          showPagination
          defaultOpenedFilters
          maxHeight="70vh"
          hasStickHeader
          filters={[
            { key: ALUNOS_FILTERS.SEARCH, name: 'Busca', component: { type: 'text', placeholder: 'Busque pelo ID, Nome, Celular ou Email' } },
          ]}
          columns={[
            { key: 'id', name: 'ID' },
            { key: 'name', name: 'Nome', isSingleLine: true, maxWidth: '300px' },
            { key: 'email', name: 'Email', isSingleLine: true, maxWidth: '300px' },
            { key: 'phone', name: 'Celular', isSingleLine: true, maxWidth: '300px' },
            { key: 'actions', name: 'Ações', isSingleLine: true },
          ]}
          rows={rows}
          page={page}
          rowsPerPage={rowsPerPage}
          isLoading={isLoading}
          selectedFilters={filters}
          totalRecords={total}
          onPageChange={changePage}
          onRowsPerChange={changeRowsPerPage}
          onSubmitFilters={changeFilters}
          onResetFilters={resetFilters}
          CustomToolbarElement={
            <Typography variant="h5" component="h1">Alunos</Typography>
          }
        />
      </Box>
    </Box>
  );
}